import classNames from "classnames";

export interface FormControlProps {
  label?: string;
  name: string;
  className?: string;
  errorMessage?: string;
  children: React.ReactNode;
}

export const FormControl: React.FC<FormControlProps> = ({
  label,
  name,
  className,
  errorMessage,
  children,
}) => (
  <div className={classNames("flex flex-col", className)}>
    {label ? (
      <label htmlFor={name} className="mb-2 text-xs 2xl:text-sm font-medium">
        {label}
      </label>
    ) : null}

    {children}

    {errorMessage ? (
      <span className="mt-1 text-sm text-app-red-500">{errorMessage}</span>
    ) : null}
  </div>
);
